import MainHeader from '$layouts/UserProfileLayout/components/MainHeader'
import { useProfileDataStore } from '$layouts/UserProfileLayout/hooks/useProfileDataStore'
import {
  innerMainContent,
  mainContent
} from '$layouts/UserProfileLayout/styles.css'
import { useMount, useRequest } from 'ahooks'
import RoleListByApp from './RoleListByApp'
import { getServiceUserRolesPermissionsGroups } from '$services/api'
import Loading from '$components/Loading'
import EmptyData from '$components/EmptyData'
import { flexColumn, flexRow } from '$styles/common.css'
import { themeVars } from '@genie-fintech/ui/style/theme'
import React, { useCallback } from 'react'
import { footnote, title } from '@genie-fintech/ui/style/typography'
import { useBreadcrumb } from '$components/Breadcrumb/hooks/useBreadcrumb'
import { Button } from '@genie-fintech/ui/components'
import { Plus } from 'lucide-react'
import { redirect, ROUTE_NAMES } from '$router/config'

const { colors } = themeVars

const Line = () => (
  <hr style={{ borderTop: `1px solid ${colors.neutral[10]}` }} />
)

const GlobalServiceUserAppsRolesPermissionsGroups = () => {
  const profile = useProfileDataStore(state => state.profile)
  const { id, name } = profile ?? {}

  const { run, loading, data } = useRequest(
    getServiceUserRolesPermissionsGroups,
    {
      manual: true
    }
  )

  useBreadcrumb([{ name: 'Apps, Roles, Permissions, Groups' }])

  useMount(() => {
    if (!id) return
    run(id)
  })

  const onAddApplication = useCallback(() => {
    redirect(
      ROUTE_NAMES.GLOBAL_SERVICE_USER_ATTACH_APP,
      ({ params, ...options }) => ({
        ...options,
        params: { ...params, serviceUserId: id }
      })
    )
  }, [id])

  const { data: list = [] } = data || {}

  const isEmpty = !list.length && !loading

  return (
    <>
      <MainHeader
        title="Applications, Roles, Permissions, Groups"
        desc="Manage and review user accounts for efficient system administration."
      />

      <article className={flexColumn} style={{ flex: 1 }}>
        <header className={mainContent} style={{ paddingBottom: 0 }}>
          <article className={innerMainContent} style={{ gap: 4 }}>
            <article className={flexRow} style={{ gap: 8 }}>
              <article className={flexColumn} style={{ flex: 1, gap: 4 }}>
                <h2 className={title.two}>
                  {name}’s ACCESS APPLICATIONS, ROLES, PERMISSIONS, GROUPS
                </h2>
                <p
                  className={footnote.one}
                  style={{ color: colors.neutral[60] }}
                >
                  You can see the user’s related information based on each
                  application level.
                </p>
              </article>
              <Button onClick={onAddApplication}>
                <Plus size={16} />
                Add Application
              </Button>
            </article>
          </article>
        </header>

        {loading && <Loading />}

        {isEmpty && <EmptyData type="data" />}

        {list.map((data, index) => (
          <React.Fragment key={index}>
            <RoleListByApp data={data} />
            <Line />
          </React.Fragment>
        ))}
      </article>
    </>
  )
}

export default GlobalServiceUserAppsRolesPermissionsGroups
